import React, { useEffect, useState } from "react";
import { Carousel } from "flowbite-react";
import { useParams, Link } from "react-router-dom";
import { IoTicketOutline } from "react-icons/io5";
import { PiHouseLineDuotone } from "react-icons/pi";
import { FaCheckCircle } from "react-icons/fa";

import carouseltheme from "../../themes/carousel.json";
import api from "../../helpers/Api";
import Loading from "../../components/Loading";
import MessageError from "../../components/MessageError";
import Ticket from "../../components/Ticket";
import moment from "moment";
import "moment/locale/es";
moment.locale("es");

export function Render({ ticketData }) {
    return (
        <div className="p-6 max-w-6xl h-full mx-auto">
            <div className="text-center mb-6">
                <div className="flex items-center justify-center gap-2 text-green-400 mb-2">
                    <FaCheckCircle className="text-2xl" />
                    <h2 className="text-3xl font-semibold text-white font-display">¡Gracias por tu compra!</h2>
                </div>
                <p className="text-gray-400 text-sm">
                    Te enviamos tus boletos por correo. También quedan disponibles en cualquier momento desde <span className="text-white font-medium">Mis Boletos</span>.
                </p>
                <div className="flex flex-wrap items-center justify-center gap-3 mt-5">
                    <Link to="/mytickets" className="thm-btn">
                        <span className="flex items-center gap-2">
                            <IoTicketOutline size={20} />
                            Ver mis boletos
                        </span>
                    </Link>
                    <Link to="/" className="thm-btn">
                        <span className="flex items-center gap-2">
                            <PiHouseLineDuotone size={20} />
                            Volver al inicio
                        </span>
                    </Link>
                </div>
            </div>
            <Carousel theme={carouseltheme} slide={false} indicators pauseOnHover className="h-[980px]">
                {ticketData.map((ticket, index) => {
                    return (
                        <div key={`${ticket.hash || ticket.number_ticket || index}`} className="flex flex-col items-center">
                            <div className="text-center text-sm text-white mb-3">
                                {index + 1} de {ticketData.length}
                            </div>
                            <Ticket ticketData={ticket} />
                        </div>
                    );
                })}
            </Carousel>
        </div>
    );
}

export default function TicketDetails() {
    const { transaction } = useParams();
    const [ticketData, setTicketData] = useState(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const ticketDataResponse = await api.get(`/Ticket/Details?transactionID=${transaction}`);
                setTicketData(ticketDataResponse.data);
            } catch (error) {
                console.error("Error fetching ticketData data:", error);
                setError(true);
            }
        };

        fetchData();
    }, [transaction]);

    if (error) {
        return (
            <MessageError
                title="Ocurrió un error al cargar tus boletos."
                description="Por favor, contacta soporte técnico o consulta tu cuenta para verlos."
            />
        );
    }

    if (!ticketData) return <Loading text={"Cargando boletos..."} />;

    return <Render ticketData={ticketData} />;
}
